import { createRouter, createWebHistory } from 'vue-router';
import SelectPackage from '../components/configurator/SelectPackage.vue';
import Compose from '../components/configurator/Compose.vue';
import Cart from '../components/Cart.vue';
import Checkout from '../components/Checkout.vue';

const routes = [
  {
    path: '/pakket-kiezen',
    component: SelectPackage,
  },
  {
    path: '/samenstellen',
    component: Compose,
  },
  {
    path: '/winkelmandje',
    component: Cart,
  },
  {
    path: '/afrekenen/',
    component: Checkout,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
